import { http } from 'http';

export default {
  createNewPartner: params => http.post('/partners', params),

  createNewCampaignByPartner: (partnerId, params) =>
    http.post(`/partners/${partnerId}/campaigns`, params),

  createNewOperationByPartner: (partnerId, params) =>
    http.post(`/partners/${partnerId}/operations`, params)
};
